export default "__VITE_ASSET__DETiwCZf__"